import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/dealeri/")({
  head: () => routeHead("/uk/dealeri/"),
  beforeLoad: () => {
    throw redirect({ href: "/uk/verified-dealers", statusCode: 301, replace: true });
  },
});
